import axios from 'axios'

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('sts_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

const saveRefreshedToken = (response) => {
  const newToken = response.headers['authorization']
  if (newToken) {
    const token = newToken.split(' ')[1]
    if (token) {
      localStorage.setItem('sts_token', token)
    }
  }
}

// A 401 means the stored token is dead and cannot be recovered. Clearing it
// without sending the user anywhere leaves them on the page they were on with
// no credentials, so every retry 401s again. Hand them to /login instead,
// preserving the package they were buying so Login can route them back.
const redirectToLogin = () => {
  if (window.location.pathname.indexOf('/login') === 0) return
  const match = window.location.search.match(/[?&]package=([^&]*)/)
  const query = match ? `?package=${match[1]}` : ''
  window.location.replace(`/login${query}`)
}

api.interceptors.response.use(
  (response) => {
    saveRefreshedToken(response)
    return response
  },
  (error) => {
    if (error.response) {
      // jwt.refresh may have rotated the token even on a failed request
      saveRefreshedToken(error.response)
      if (error.response.status === 401) {
        localStorage.removeItem('sts_token')
        redirectToLogin()
      }
    }
    return Promise.reject(error)
  },
)

export default api



// WEBPACK FOOTER //
// ./src/data/axios.js